import { CheckCircle, WarningCircle } from '@phosphor-icons/react';
import { AccentButton } from '../../../../../../shared/Buttons';
import { Entity } from '../../../../../../types/apiTypes';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';
import { useUser } from '../../../../../../utils/UserContext';
import { useNavigate } from 'react-router-dom';

function GetStartedVendorsWidget({
  promotionCount,
  locationCount,
}: {
  promotionCount: number;
  locationCount: number;
}) {
  const { userRecord } = useUser();
  const { screenView } = useScreenView();
  const navigate = useNavigate();
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          userRecord &&
          userRecord?.userType === Entity.Vendor &&
          (locationCount === 0 || promotionCount === 0) && (
            <div className="flex w-full flex-col gap-y-6 bg-ctaactivegreen p-6">
              <h2 className="text-[20px] font-semibold text-primary">
                Complete Account Setup (
                {(locationCount > 0 ? 1 : 0) + (promotionCount > 0 ? 1 : 0)}/2)
              </h2>
              <div className="grid w-[100%] items-center justify-center gap-3 align-middle sm:grid-cols-1 lg:grid-cols-2 lg:grid-rows-1">
                <div
                  className={`radius-[4px] flex w-full flex-row items-center justify-between bg-white p-4 align-middle sm:h-[180px] sm:max-h-[180px] md:h-[90px] md:max-h-[90px] ${promotionCount > 0 && 'opacity-70'}`}
                >
                  <div className="flex w-full flex-row items-center justify-between align-middle">
                    <div className="flex w-[75%] flex-row items-center space-x-2 align-middle">
                      {promotionCount > 0 ? (
                        <CheckCircle
                          weight="fill"
                          className={`w-[15%] text-4xl text-primary`}
                        />
                      ) : (
                        <WarningCircle
                          weight="fill"
                          className={`w-[15%] text-4xl text-ctaactivegreen`}
                        />
                      )}
                      <div className="flex w-[85%] flex-col items-start justify-start">
                        <h2 className="text-[16px] text-primary">
                          Add Promotion
                        </h2>
                        <p className="text-[14px] text-graysecondary">
                          Add the first promotion or deal for your business.
                        </p>
                      </div>
                    </div>
                    {promotionCount === 0 ? (
                      <AccentButton
                        onClick={() => navigate('/dashboard/promotions/create')}
                        addClass="rounded-full py-[6px]"
                      >
                        Start
                      </AccentButton>
                    ) : (
                      <div className="rounded-full bg-primary px-2 py-[1px] text-white">
                        Completed
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={`radius-[4px] flex w-full flex-row items-center justify-between bg-white p-4 align-middle sm:h-[180px] sm:max-h-[180px] md:h-[90px] md:max-h-[90px] ${locationCount > 0 && 'opacity-70'}`}
                >
                  <div className="flex w-full flex-row items-center justify-between align-middle">
                    <div className="flex w-[75%] flex-row items-center space-x-2 align-middle">
                      {locationCount > 0 ? (
                        <CheckCircle
                          weight="fill"
                          className={`w-[15%] text-4xl text-primary`}
                        />
                      ) : (
                        <WarningCircle
                          weight="fill"
                          className={`w-[15%] text-4xl text-ctaactivegreen`}
                        />
                      )}
                      <div className="flex w-[85%] flex-col items-start justify-start">
                        <h2 className="text-[16px] text-primary">
                          Add Business Location
                        </h2>
                        <p className="text-[14px] text-graysecondary">
                          Add all of your business locations to make them
                          available for carriers to find.
                        </p>
                      </div>
                    </div>
                    {locationCount === 0 ? (
                      <AccentButton
                        onClick={() => navigate('/dashboard/locations/create')}
                        addClass="rounded-full py-[6px]"
                      >
                        Start
                      </AccentButton>
                    ) : (
                      <div className="rounded-full bg-primary px-2 py-[1px] text-white">
                        Completed
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default GetStartedVendorsWidget;
